import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  href?: string;
  className?: string;
}
export function Button({
  children,
  href,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-medium transition-all duration-300 rounded-sm bg-gold-500 text-navy-900 hover:bg-gold-400 hover:-translate-y-1 hover:shadow-[0_0_25px_rgba(212,165,116,0.4)] focus:outline-none focus:ring-2 focus:ring-gold-400 focus:ring-offset-2 focus:ring-offset-navy-900';
  if (href) {
    return <a href={href} className={`${baseStyles} ${className}`} data-id="element-376">
        {children}
      </a>;
  }
  return <button className={`${baseStyles} ${className}`} {...props} data-id="element-377">
      {children}
    </button>;
}